/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-24 22:18:48
 * @Introduction: 设置模块路由
 */

import { RouteConfig } from 'vue-router'

const SettingRecommendNews = () => import('@/views/setting/recommend.vue')
const SettingBanner = () => import('@/views/setting/banner.vue')
const SettingAppVersion = () => import('@/views/setting/appVersion.vue')
const SettingActivity = () => import('@/views/setting/activity.vue')
const SettingHotWord = () => import('@/views/setting/hotWord.vue')
const SettingClueRecommend = () => import('@/views/setting/clue/recommend/index.vue')
const SettingClueRecommendDetail = () => import('@/views/setting/clue/recommend/detail.vue')
const SettingMediaCircle = () => import('@/views/setting/media_circle/index.vue')
const SettingMediaCircleEdit = () => import('@/views/setting/media_circle/edit.vue')
const SettingMediaCircleCreate = () => import('@/views/setting/media_circle/create.vue')
const SettingRecruit = () => import('@/views/setting/recruit/index.vue')
const SettingCreateRecruit = () => import('@/views/setting/recruit/create.vue')
const SettingRecruitDetail = () => import('@/views/setting/recruit/detail.vue')
const SettingBulletinList = () => import('@/views/setting/bulletin/index.vue')
const SettingBulletinDetail = () => import('@/views/setting/bulletin/detail.vue')
const SettingHelp = () => import('@/views/setting/help/index.vue')
const SettingHelpTypeDetail = () => import('@/views/setting/help/type/_id.vue')
const SettingHelpTypeCreate = () => import('@/views/setting/help/type/create.vue')
const SettingHelpArticleList = () => import('@/views/setting/help/article/list.vue')
const SettingHelpArticleCreate = () => import('@/views/setting/help/article/create.vue')
const SettingHelpArticleDetail = () => import('@/views/setting/help/article/_id.vue')
const SettingHelpGuideList = () => import('@/views/setting/help/guide/list.vue')
const SettingHelpGuideCreate = () => import('@/views/setting/help/guide/create.vue')

/* Layout */
import Layout from '@/layout/index.vue'
/* Children Layout */
import ChildLayout from '@/layout/children_layout.vue'

const settingRoute: RouteConfig = {
    path: '/setting',
    component: Layout,
    redirect: '/setting/banner',
    meta: {
        title: '配置',
        icon: 'icon-setting',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'banner',
            component: SettingBanner,
            name: 'SettingBanner',
            meta: {
                title: '网站首页'
            }
        },
        {
            path: 'app-version',
            component: SettingAppVersion,
            name: 'SettingAppVersion',
            meta: {
                title: 'APP 版本'
            }
        },
        {
            path: 'activity',
            component: SettingActivity,
            name: 'SettingActivity',
            meta: {
                title: '活动管理'
            }
        },
        {
            path: 'mc',
            component: ChildLayout,
            meta: {
                title: '传媒圈配置'
            },
            children: [
                {
                    path: '',
                    component: SettingMediaCircle,
                    name: 'SettingMediaCircle',
                    meta: {
                        title: '传媒圈配置'
                    }
                },
                {
                    path: 'create',
                    component: SettingMediaCircleCreate,
                    name: 'MediaCircleCreate',
                    meta: {
                        title: '传媒圈创建',
                        hidden: true
                    }
                },
                {
                    path: ':id',
                    component: SettingMediaCircleEdit,
                    name: 'MediaCircleEdit',
                    meta: {
                        title: '传媒圈编辑',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'clue',
            component: ChildLayout,
            meta: {
                title: '推荐线索'
            },
            children: [
                {
                    path: '',
                    component: SettingClueRecommend,
                    name: 'ClueRecommend',
                    meta: {
                        title: '推荐线索'
                    }
                },
                {
                    path: ':id',
                    component: SettingClueRecommendDetail,
                    name: 'ClueRecommendDetail',
                    meta: {
                        title: '推荐线索详情',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'hot-word',
            component: SettingHotWord,
            name: 'SettingHotWord',
            meta: {
                title: '牛媒热搜'
            }
        },
        {
            path: 'recommend',
            component: SettingRecommendNews,
            name: 'SettingRecommendNews',
            meta: {
                title: '推荐新闻'
            }
        },
        {
            path: 'recruit',
            component: ChildLayout,
            meta: {
                title: '招聘信息'
            },
            children: [
                {
                    path: '',
                    component: SettingRecruit,
                    name: 'SettingRecruit',
                    meta: {
                        title: '招聘信息'
                    }
                },
                {
                    path: 'new',
                    component: SettingCreateRecruit,
                    name: 'SettingCreateRecruit',
                    meta: {
                        title: '新增招聘信息',
                        hidden: true
                    }
                },
                {
                    path: ':id',
                    component: SettingRecruitDetail,
                    name: 'SettingRecruitDetail',
                    meta: {
                        title: '编辑招聘信息',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'bulletin',
            component: ChildLayout,
            meta: {
                title: '公告栏'
            },
            children: [
                {
                    path: '',
                    component: SettingBulletinList,
                    name: 'SettingBulletinList',
                    meta: {
                        title: '公告栏'
                    }
                },
                {
                    path: 'new',
                    component: SettingBulletinDetail,
                    name: 'CreateSettingBulletin',
                    meta: {
                        title: '新增公告栏',
                        hidden: true
                    }
                },
                {
                    path: ':id',
                    component: SettingBulletinDetail,
                    name: 'SettingBulletinDetail',
                    meta: {
                        title: '公告栏详情',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'help',
            component: ChildLayout,
            meta: {
                title: '帮助中心'
            },
            children: [
                {
                    path: '',
                    component: SettingHelp,
                    name: 'HelpCenter',
                    meta: {
                        title: '帮助中心'
                    }
                },
                {
                    path: 'type/create',
                    component: SettingHelpTypeCreate,
                    name: 'HelpCenterCreateType',
                    meta: {
                        title: '创建分类',
                        hidden: true
                    }
                },
                {
                    path: 'type/:id',
                    component: SettingHelpTypeDetail,
                    name: 'HelpCenterTypeDetail',
                    meta: {
                        title: '分类详情',
                        hidden: true
                    }
                },
                {
                    path: 'article/list',
                    component: SettingHelpArticleList,
                    name: 'HelpCenterArticleList',
                    meta: {
                        title: '文章列表',
                        hidden: true
                    }
                },
                {
                    path: 'article/create',
                    component: SettingHelpArticleCreate,
                    name: 'HelpCenterArticleCreate',
                    meta: {
                        title: '创建文章',
                        hidden: true
                    }
                },
                {
                    path: 'article/:id',
                    component: SettingHelpArticleDetail,
                    name: 'HelpCenterArticleDetail',
                    meta: {
                        title: '文章详情',
                        hidden: true
                    }
                },
                {
                    path: 'guide/list',
                    component: SettingHelpGuideList,
                    name: 'HelpCenterGuideList',
                    meta: {
                        title: '引导页列表',
                        hidden: true
                    }
                },
                {
                    path: 'guide/create',
                    component: SettingHelpGuideCreate,
                    name: 'HelpCenterGuideCreate',
                    meta: {
                        title: '新增引导页',
                        hidden: true
                    }
                }
            ]
        }
    ]
}

export default settingRoute
